import './styles.css';
import { mount, clear } from '@ui/dom';
import { onRouteChange, startRouter, navigate } from '@ui/router';
import { renderLobby } from '@ui/lobby';
import { renderSetup } from '@ui/setup';
import { renderPlay } from '@ui/play';
import { showConsentBanner } from '@ui/privacy';
import { registerGame } from '@core/game-registry';
import { setLang, getLang } from '@core/i18n';
import { globeGame } from '@games/globe';
import { animalsGame } from '@games/animals';
import { renderArcade } from '@games/arcade';
import { copy } from '@games/arcade/catalog';
import { el } from '@ui/dom';

// Init lingua
setLang(getLang());

// Registra giochi (cuore dell'estendibilità: aggiungere qui altri moduli)
registerGame(globeGame);
registerGame(animalsGame);

const app = document.getElementById('app')!;
let routeVersion = 0;
let currentView: (HTMLElement & { dispose?: () => void }) | null = null;

onRouteChange(async (route) => {
  const version = ++routeVersion;
  currentView?.dispose?.();
  currentView = null;
  clear(app);
  app.append(el('div', { class: 'p-6 text-center text-sm text-slate-400' }, [copy('Un attimo, preparo il divertimento…', 'One moment, preparing the fun…')]));
  let view: HTMLElement;
  try {
    if (route.name === 'lobby') view = await renderLobby();
    else if (route.name === 'arcade') view = renderArcade(route.gameId);
    else if (route.name === 'setup') view = renderSetup(route.gameId);
    else view = await renderPlay(route.gameId, route.sessionId);
  } catch (e) {
    console.error(e);
    view = el('main', { class: 'p-6 max-w-xl mx-auto mt-12 grid gap-4' }, [
      el('h1', { class: 'text-2xl font-bold' }, [copy('Il gioco si è preso una pausa.', 'The game took a break.')]),
      el('p', { class: 'text-slate-300 text-sm' }, [copy('Non riesco a caricare questa pagina. Controlla la connessione e riprova.', 'This page could not be loaded. Check your connection and try again.')]),
      el('div', { class: 'flex gap-3' }, [el('button', { class: 'btn-primary', on: { click: () => navigate(route) } }, [copy('Riprova', 'Try again')]), el('button', { class: 'btn-ghost', on: { click: () => navigate({ name: 'lobby' }) } }, ['← Gamez'])]),
    ]);
  }
  if (version !== routeVersion) {
    (view as HTMLElement & { dispose?: () => void }).dispose?.();
    return;
  }
  currentView = view;
  mount(app, view);
});

startRouter();
showConsentBanner();
